import { store } from '../store';
import { ConfigEnvironmentVariableLinksResponseInterface } from '@types';
import { ConfigKeys } from '@enums';

export const executeLink = (key: ConfigKeys, isEmail = false) => {
  let configVariables: ConfigEnvironmentVariableLinksResponseInterface;
  if (store) {
    configVariables = store.getState()?.appEnvironmentReducer.configVariables;
  }
  if (isEmail) {
    return `mailto:${configVariables[key]}`
  }
  return configVariables[key];
};
